<template>
  <div class="main">
    <nav class="navbar fixed-top navbar-expand-lg navbar-dark navbar-hs321">
      <router-link to="/" class="navbar-brand">
        <img :src="logo" alt="hardsoft321" class="navbar-brand-img-hs321">
      </router-link>

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item mr-sm-2">
            <a href="https://hardsoft321.org/" target="_blank" class="btn btn-purple ml-auto" role="button" aria-pressed="true">Внедрение ПО</a>
          </li>
          <li class="nav-item mr-auto">
            <a href="https://bush10.org/" target="_blank" class="btn btn-warning ml-auto" role="button" aria-pressed="true">Консалтинг</a>
          </li>
        </ul>
      </div>

    </nav>
  </div>
</template>

<script>
  export default {
    name: 'Menu',
    data () {
      return {
        msg: '',
        logo: require('@/assets/img/lab321logo.png'),
      }
    }
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .navbar-hs321 {
    border-bottom: 1px solid #ebebeb;;
    transition: 0.3s;
    background-color: #3f4652;
  }

  .navbar-hs321 .navbar-brand img {
    transition: 0.3s;
  }
  .navbar-brand-img-hs321 {
    width: 190px;
    height: 73px;
  }

  .navbar-nav .nav-item .nav-link {
    color: #fff;
  }

  .navbar-nav .nav-item.active .nav-link,
  .navbar-nav .nav-item:hover .nav-link,
  .navbar-light .navbar-nav .nav-link:focus {
    color: #5faafb;
  }
  .navbar-light .navbar-nav .nav-link:focus, .navbar-light .navbar-nav .nav-link:hover {
    color: #000;
  }
  .dropdown-item.active, .dropdown-item:active {
    color: #5faafb;
    text-decoration: none;
    background-color: #3f4652;
  }

  .icons-navbar-hs312 {
    color: white;
    font-size: 2em;
  }
  @media (max-width: 991.98px) {
    .navbar-hs321 {
      border-color: #ebebeb;
      background-color: #3f4652;
    }
    .navbar-brand-img-hs321-small {
      width: 190px;
      height: 76px;
    }
    .navbar-brand-img-hs321 {
      width: 215px;
      height: 86px;
    }
    .nav-item {
      margin-bottom: 5px;
    }
  }
/* custom purple button */
  .btn-outline-purple {
    color: #a066ff;
    background-color: transparent;
    background-image: none;
    border-color: #a066ff;
  }
  .btn-outline-purple:hover {
    color: #fff;
    background-color: #a066ff;
    border-color: #a066ff;
  }
  .btn-purple {
    color: #ffffff;
    background-color: #9351ff;
    border-color: #9351ff;
  }
  .btn-purple:hover,
  .btn-purple:focus,
  .btn-purple:active,
  .btn-purple.active,
  .open .dropdown-toggle.btn-purple {
    color: #ffffff;
    background-color: #9351ff;
    border-color: #9351ff;
  }
  .btn-purple:active,
  .btn-purple.active,
  .open .dropdown-toggle.btn-purple {
    background-image: none;
  }

  .btn-purple.disabled,
  .btn-purple[disabled],
  fieldset[disabled] .btn-purple,
  .btn-purple.disabled:hover,
  .btn-purple[disabled]:hover,
  fieldset[disabled] .btn-purple:hover,
  .btn-purple.disabled:focus,
  .btn-purple[disabled]:focus,
  fieldset[disabled] .btn-purple:focus,
  .btn-purple.disabled:active,
  .btn-purple[disabled]:active,
  fieldset[disabled] .btn-purple:active,
  .btn-purple.disabled.active,
  .btn-purple[disabled].active,
  fieldset[disabled] .btn-purple.active {
    background-color: #611BBD;
    border-color: #130269;
  }

  .btn-purple .badge {
    color: #611BBD;
    background-color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/PageMenu.vue